import { useRef, useEffect, useState } from "react";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevron-down.svg";
import { getFinalStatusOptions } from "./StatusInputSelect";

export function CallFlowStatusSelect({
  value,
  onChange,
  options,
  readonly,
  certificationAssets,
}: {
  value: string;
  onChange: (value: string) => void;
  options?: any[];
  readonly?: boolean;
  certificationAssets?: any;
}) {
  const [show, setShow] = useState(false);
  const selectedOption = certificationAssets?.userStatus?.[value] || certificationAssets?.userStatus?.pending;
  const containerRef = useRef(null);

  useEffect(() => {
    // Implement outside click handler
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !(containerRef.current as HTMLElement).contains(event.target as Node)
      ) {
        setShow(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-fit" ref={containerRef}>
      <button
        onClick={() => !readonly && setShow(!show)}
        disabled={readonly}
        className={`w-full h-[clamp(20px,2.5vw,24px)] flex items-center gap-1 justify-center rounded-full px-4 bg-[#959595]`}
        style={{
          backgroundColor: selectedOption?.textColor,
        }}
      >
        <div className="text-center font-medium text-[11px] text-white">
          {selectedOption?.label || (readonly ? "N/A" : "Select Status")}
        </div>
        {!readonly && <ChevronDown className={`${show ? "rotate-[180deg]" : ""} w-4 h-4 [&_path]:stroke-white`} />}
      </button>
      {show && !readonly && (
        <div className="absolute z-[2] top-8 left-0 w-full bg-white shadow-lg rounded-lg flex flex-col">
          {getFinalStatusOptions(certificationAssets)?.map((opt) => (
            <button
              onClick={() => {
                onChange(opt.value);
                setShow(false);
              }}
              className="h-[30px] text-black flex items-center font-medium justify-center hover:bg-gray-100 text-[11px]"
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
